var exports = {
  "DD": "x7f9a0e16--e320dc--title",
  "os": "x7f9a0e16--e320dc--centered-title",
  "kL": "x7f9a0e16--e320dc--container",
};

module.exports = exports;
